<script lang="ts">
    export let size: number, color: string
</script>

<svg fill="none" viewBox="0 0 24 24" width={size} height={size} xmlns="http://www.w3.org/2000/svg">
    <circle style="stroke: {color}; stroke-width: 2px;" cx="18" cy="5" r="3" />
    <circle style="stroke: {color}; stroke-width: 2px;" cx="6" cy="12" r="3" />
    <circle style="stroke: {color}; stroke-width: 2px;" cx="18" cy="19" r="3" />
    <line style="stroke: {color}; stroke-width: 2px;" x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line style="stroke: {color}; stroke-width: 2px;" x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
</svg>
